import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=1f28a047&"
import script from "./swiper.vue?vue&type=script&lang=js&"
export * from "./swiper.vue?vue&type=script&lang=js&"
import style0 from "./swiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f28a047')) {
      api.createRecord('1f28a047', component.options)
    } else {
      api.reload('1f28a047', component.options)
    }
    module.hot.accept("./swiper.vue?vue&type=template&id=1f28a047&", function () {
      api.rerender('1f28a047', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/swiper/swiper.vue"
export default component.exports